<template>
    <g clip-path="url(#clip0_1199_10582)">
        <path
            d="M117.068 16.9065C115.303 15.1381 112.439 15.1351 110.674 16.899L56.4174 71.0119L36.8419 49.7511C35.1504 47.915 32.2906 47.7959 30.4515 49.4872C28.6137 51.1787 28.4961 54.0399 30.1876 55.8776L52.9515 80.5998C53.7851 81.5058 54.9519 82.032 56.1821 82.0576C56.2151 82.059 56.247 82.059 56.2786 82.059C57.4742 82.059 58.6243 81.5841 59.4715 80.7399L117.06 23.3028C118.829 21.5391 118.832 18.6748 117.068 16.9065Z"
        />
        <path
            d="M115.977 55.9773C113.479 55.9773 111.455 58.0018 111.455 60.5C111.455 88.5976 88.5976 111.455 60.5 111.455C32.4041 111.455 9.54523 88.5976 9.54523 60.5C9.54523 32.4041 32.4041 9.54523 60.5 9.54523C62.998 9.54523 65.0227 7.5207 65.0227 5.02273C65.0227 2.52453 62.998 0.5 60.5 0.5C27.4156 0.5 0.5 27.4156 0.5 60.5C0.5 93.583 27.4156 120.5 60.5 120.5C93.583 120.5 120.5 93.583 120.5 60.5C120.5 58.002 118.475 55.9773 115.977 55.9773Z"
        />
    </g>
    <defs>
        <clipPath id="clip0_1199_10582">
            <rect width="120" height="120" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
    </defs>
</template>
